var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticStyle:{"transform":"scale(1.3)"}},[_c('path',{attrs:{"opacity":"0.4","d":"M3.5 0L6.53109 5.25H0.468911L3.5 0Z","fill":"#102F35"}}),_c('path',{attrs:{"d":"M3.5 13L6.53109 7.75H0.468911L3.5 13Z","fill":"#102F35"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }